module.exports = __webpack_public_path__ + "static/media/upload-bg.3ed9f441.png";